<template>
  <div>
   <v-btn :href='channel.url' text left class="text-xs-left">
      <div v-if='live' class='live'></div><img v-if='channel.partner' class='partner' src='@/assets/partner.png' />{{channel.display_name.trim()}}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TwitchChannelLink',
  props: {
    channel: {},
    live: {},
  },
}
</script>

<style>
  .v-btn.text-xs-left > div.v-btn__content {
    text-align: left;
    align-items: start;
    justify-content: start;
  }

  a.v-btn {
    padding: 0;
    padding-left: 5px;
    padding-right: 5px;
    margin: 0;
    left: 0px;
  }

  .partner {
    display: inline-block;
    margin-right: 3px;
    vertical-align: text-bottom;
  }

  .live {
      background: #f00;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
      margin-right: 4px;
      display: inline-block;
  }
</style>